import { sendaForClass, type HeroClass, type SendaCast } from '@somnhold/content';
import { heroKey } from './library.ts';

/**
 * The paths' people (docs/SENDAS.md): how each is drawn, from its path's cast (content `SendaDef.cast`). One of the
 * sagas' people stands posed like a hero (`ally:<npc>`); the rest are a hero's miniature of a class at a tier, in a
 * look. Someone the cast doesn't name is drawn as the path's class, plain (never a missing model).
 */

/** A level in each miniature tier (heroTier reads it back). */
const TIER_LEVEL = { 1: 1, 2: 4, 3: 7, 4: 10 } as const;

/** The library key of a cast member (`rigged`: a hero's miniature through the rig, as the board draws heroes). */
export const castKey = (c: SendaCast | undefined, cls: HeroClass, rig: (k: string) => string): string =>
  c?.npc ? `ally:${c.npc}` : c?.model ? rig(`senda:${c.model}`) : rig(heroKey(c?.cls ?? cls, TIER_LEVEL[c?.tier ?? 2], false, c?.look));

/** Who `who` is in the path of a hero of `cls` (a memory's face, a person on the field). */
export const sendaCast = (cls: HeroClass, who: string): SendaCast | undefined => sendaForClass(cls)?.cast?.[who];
